import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./index.scss";
import { Button, Col, Row } from "reactstrap";
import Select from 'react-select';
import moment from 'moment-timezone';
const { DateTime } = require('luxon');


const timeZones = moment.tz.names();

const customStyles = {
  // Add your custom styles here, such as height
  menu: (provided, state) => ({
    menu: (provided) => ({
      ...provided,
      top: `200 px`,
    }),
  }),
};

const UserTimezone = ({ selectedTimeZone, onSelect, onSubmit }) => {
  const userDetail = useSelector((state) => state?.user?.user);
  const [timezone, setTimezone] = useState('');
  const [time, setTime] = useState('');
  const [currentTime, setCurrentTime] = useState('');

  const getTimeZone = ()=>{
    const currentTimeZone = DateTime.local().zoneName;
    const timeZoneDateTime = DateTime.now().setZone(currentTimeZone);
    setTime(moment.tz(timeZoneDateTime.ts, currentTimeZone).format('MM/DD/YYYY, h:mm A'))
    const timezoneAbbr = moment.tz(currentTimeZone).format('z');
    setTimezone(`${currentTimeZone} ${timezoneAbbr}`);
  }

  useEffect(()=>{
    if(userDetail?.timezone && userDetail.isTimezoneSet){
      const timezoneAbbr = moment.tz(userDetail.timezone).format('z');
      setTime(moment().tz(userDetail.timezone).format('MM/DD/YYYY, h:mm A'))
      setTimezone(`${userDetail.timezone} (${timezoneAbbr})`);
    }
  },[time, timezone])

  useEffect(() => {
    const interval = setInterval(() => getTimeZone(), 1000);
    window.addEventListener('timezonechange', getTimeZone());

    return () => {
      clearInterval(interval);
      window.removeEventListener('timezonechange', getTimeZone());
    };
  }, []);

    // const options = timeZones.map((tz) => ({ value: tz, label: tz }))
    const options = timeZones.map((tz) => {
        const timeZone = moment.tz(tz);
        const timeZoneAbbreviation = timeZone.format('z');
        return {
          value: tz,
          label: `${tz} (${timeZoneAbbreviation})`
        };
    });

    useEffect(() => {
        if (selectedTimeZone) {
          const intervalId = setInterval(() => {
            setCurrentTime(moment().tz(selectedTimeZone.value).format('MM/DD/YYYY, h:mm A'));
          }, 1000);
    
          return () => clearInterval(intervalId);
        }
      }, [selectedTimeZone]);
    
    const handleSubmit = () => {
      onSubmit(selectedTimeZone.value);
    };

    return (
        <>
        <div className="profile-form-wrapper">
          <div className="inner">
            <Row>
            {(timezone && time) && 
              (<><Col sm="12">
                <div className="input-wrapper form-group">
                  {`Preferred Timezone: ${timezone}`}
                </div>
              </Col>
              <Col sm="12">
                  <div className="input-wrapper form-group">
                    {`Preferred Timezone time: ${time}`}
                  </div>
                </Col></>)}
              <Col sm="12">
                 <div className="input-wrapper form-group">
                  <h5>Select Timezone</h5> 
                 </div>
              </Col>
              <Col sm="12">
                <div className="input-wrapper form-group">
                  <Select
                    options={options}
                    value={selectedTimeZone}
                    onChange={onSelect}
                    styles={customStyles}
                    isSearchable
                    placeholder="Select a timezone..."
                  />
                </div>
              </Col>
              <Col sm="12">
                <div className="input-wrapper form-group">
                {selectedTimeZone && (
                  <div className="input-wrapper form-group">
                    <div className="mb-3">Selected timezone : {selectedTimeZone.label}</div>
                    {currentTime && <div>Selected Timezone (date/time): {currentTime}</div>}
                  </div>
                )}
                </div>
              </Col>
              {selectedTimeZone && (
              <Col sm="12">
                <div className="input-wrapper form-group">
                  <Button color="primary" className="mx-auto" onClick={handleSubmit}>Submit</Button>
                </div>
              </Col>
              )}
            </Row>
          </div>
        </div>
        </>
    )
}

export default UserTimezone;